import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/securitySchemes';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.SECURITY_SCHEME);

export const useSecuritySchemeById = ({ sessionToken, schemeId, queryOptions = {} }) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(schemeId),
        queryFn: () => Client.fetchOne(sessionToken, schemeId),
        onSuccess: (data) => {
            // console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: typeof schemeId !== 'undefined' && schemeId !== 'new',
        ...queryOptions
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
